export default __webpack_public_path__ + "static/media/trampapo_02_21.c52e021d.jpg";